/** Domain types shared by the API and both front ends. Mirrors the enums in migration 0100. */
export const REQUEST_STATUS_LABELS = {
    draft: 'Draft',
    sent: 'Sent',
    viewed: 'Viewed',
    submitted: 'Submitted',
    recorded: 'Recorded',
    cancelled: 'Cancelled',
    expired: 'Expired',
};
//# sourceMappingURL=types.js.map